import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";
import moment from "moment";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import Seccion from "../../Seccion";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CurrencyInput from "react-currency-input-field";
import { formatValue } from "react-currency-input-field";

function SaldoInicialCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_SALDO_INICIAL = process.env.REACT_APP_URL_SALDO_INICIAL;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [clientes, setClientes] = useState([]);

  const [fecha, setFecha] = useState(hoy);

  const [importe, setImporte] = useState(0);
  const [observaciones, setObservaciones] = useState("NA");

  const [value, setValue] = useState("");
  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

   
  }, []);

  const saveSaldoInicial = (event) => {
    event.preventDefault();
    setValidaBoton(false);

        axios.post(
          URL_SALDO_INICIAL,
          {
            fecha,
            importe,
            observaciones,
            clientes: value._id,
            saldo: importe,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Saldo Inicial",
            detalle: `Fecha: ${fecha} / Cliente: ${value.nombre_comercial} / Importe: ${importe} `,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        Swal.fire("Listo", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Algo salio mal",
          text: "No se pudo completar",
        });
        console.log(error);
        setValidaBoton(true);
      });
  };

  const options = clientes.map((option) => {
    const junta = option.nombre_comercial + " " + option.codigo;
    const firstLetter = option.nombre_comercial[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  return (
    <>
      <Header />
      <br />
      <br />
      {user.notasCargoCreate ? (
        <div className="container">
          <div className="card container col-sm-9">
            <div className="page-header"><div><h3 className="page-title">Nuevo Saldo Inicial</h3></div></div>
            <Form onSubmit={saveSaldoInicial}>
              <Seccion titulo="Saldo inicial" icono="fas fa-balance-scale">
<Row>
<Col md={6}>
                    <Label className="mr-sm-2">Fecha</Label>
                    <Input
                      type="date"
                      value={fecha}
                      onChange={(e) => {
                        setFecha(e.target.value);
                      }}
                    />
                  </Col>
<Col md={6}>
                    <Label className="mr-sm-2">Cliente</Label>
                    <Autocomplete
                      size="small"
                      value={value}
                      onChange={(event, selectedCliente) => {
                        if (selectedCliente) {
                          setValue(selectedCliente);
                        }
                      }}
                      options={options.sort(
                        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                      )}
                      groupBy={(option) => option.firstLetter}
                      getOptionLabel={(option) => option.junta}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecciona"
                          variant="outlined"
                        />
                      )}
                      renderOption={(option) => (
                        <React.Fragment>
                          {option.codigo} {option.nombre_comercial}
                        </React.Fragment>
                      )}
                    />
                  </Col>
<Col sm={6}>
                    <Label className="mr-sm-2">Importe</Label>

                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={importe}
                      className={`form-control`}
                      onValueChange={(value, name) => setImporte(value).toFixed(2)}
                    />
                  </Col>
<Col md={6}>
                    <Label className="mr-sm-2">Observaciones</Label>
                    <Input
                      type="text"
                      value={observaciones}
                      onChange={(e) => {
                        setObservaciones(e.target.value);
                      }}
                    />
                  </Col>
</Row>
</Seccion>
<div className="form-acciones">
<Button
                    href="/ListadoSaldoInicial"
                    className="btn btn-secondary"
                  >
                    Regresar
                  </Button>
{validaBoton ? (
                    <Button type="submit" className="btn btn-primary">
                      Guardar
                    </Button>
                  ) : (
                    <Button type="submit" className="btn btn-primary" disabled>
                      Guardar
                    </Button>
                  )}
</div>
<div>
                    <SweetAlert
                      show={text}
                      title="Creado con Exito"
                      onConfirm={() => {
                        setText(false);
                      }}
                    />
                  </div>

            </Form>
          </div>
        </div>
      ) : undefined}
    </>
  );
}

export default SaldoInicialCreate;
